<template>
  <div class="bg-grey-500" style="height:100vh;overflow-y:auto;">

    <app-header @click="onHeaderEmitted()">{{ $t('instructions.instrucciones') }}</app-header>

    <div class="section animate__animated animate__fadeInUp animate__faster">
      <div class="section">
        <h2 class="text-3xl mt-0 mb-2">{{ $t('instructions.ronda-1') }}</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque at odio posuere, bibendum dui eget, fermentum sapien. Aenean vestibulum non ligula vel condimentum.
        </p>
        <p>
          Ut non erat eget felis efficitur vulputate ac ut eros. Sed ac felis accumsan, accumsan sapien eget, iaculis mi. Duis dignissim ultricies tristique. Aenean euismod consequat tellus, at accumsan ligula faucibus vel. In hac habitasse platea dictumst. Cras nisl neque, dignissim et aliquet vel, molestie eu nisl. Nulla facilisi. Phasellus sit amet aliquet justo. Vivamus ut ultrices erat. Donec hendrerit blandit magna eget condimentum.
        </p>
        <h2 class="text-3xl mt-8 mb-2">{{ $t('instructions.ronda-2') }}</h2>
        <p>
          Integer sit amet ultrices velit. Pellentesque nec porttitor leo. Phasellus vulputate ligula sit amet neque ornare accumsan. Curabitur molestie suscipit viverra. Donec euismod, metus ac efficitur egestas, turpis mauris malesuada ipsum, in sagittis massa diam ut massa. Fusce a volutpat libero. In aliquam libero quis dapibus bibendum.
        </p>
        <p>
          Etiam aliquam nulla dolor, nec accumsan lorem bibendum quis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Donec malesuada auctor ligula consequat commodo. Morbi turpis ligula, pretium et sagittis non, ullamcorper sit amet libero.
        </p>
        <h2 class="text-3xl mt-8 mb-2">{{ $t('instructions.ronda-3') }}</h2>
        <p>
          Cras euismod gravida arcu mollis ultricies. Integer sagittis tristique odio in blandit. Quisque gravida, neque vitae hendrerit porttitor, sem lorem blandit nisi, a pellentesque ligula tellus vel quam. Maecenas tortor diam, aliquam in dui finibus, fermentum tristique nisl. Curabitur porttitor augue vel nulla consequat consectetur.
        </p>
        <p>
          Sed id metus pharetra arcu condimentum condimentum. Fusce aliquam lacus ac felis faucibus volutpat. Fusce gravida eros eu finibus ullamcorper.
        </p>
      </div>
      <div style="clear:both;height:1rem;"></div>
      <div class="section">
        <button class="button is-blue w-full text-white" @click="onPlayClicked()">
          Empezar a jugar
        </button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "app-instructions",
  data() {
    return {
      msg: "Rules to Your Vue.js PWA",
    };
  },
  methods: {
    onHeaderEmitted() {
      this.$router.replace("/");
    },
    onPlayClicked() {
      this.$router.push("playing");
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495e;
}
</style>



// WEBPACK FOOTER //
// src/pages/01-Instructions.vue